module.exports = __webpack_public_path__ + "img/blue-pluss.cca35deb.svg";